import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataResolverService } from './resolvers/data-resolver.service';
import { treasureHuntResolverService } from './resolvers/treasure_hunt-resolver.service';
import { AuthGuard } from './guards/auth.guard';
import { LoginResolverService } from './resolvers/login-resolver.service';
import { CurrentTourResolverService } from './resolvers/currentTour-resolver.service';
import { LeagueResolverService } from './resolvers/league.resolver.service';
const ROUTES: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    loadChildren: () =>
      import('./pages/rapid-tour/rapid-journey/rapid-journey.module').then(
        (m) => m.RapidJourneyPageModule
      ),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./pages/dashboard/dashboard.module').then((m) => m.DashboardPageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.module').then((m) => m.ProfilePageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'profile-info',
    loadChildren: () =>
      import('./pages/profile-info/profile-info.module').then((m) => m.ProfileInfoPageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'take-bog-tour',
    loadChildren: () =>
      import('./pages/take-bog-tour/take-bog-tour.module').then((m) => m.TakeBogTourPageModule),
    canActivate: [AuthGuard],
    resolve: {
      appData: DataResolverService,
      currentTour: CurrentTourResolverService,
    },
  },
  {
    path: 'add-qr',
    loadChildren: () => import('./pages/add-qr/add-qr.module').then((m) => m.AddQrPageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'qr-code-scanner',
    loadChildren: () =>
      import('./pages/qr-code-scanner/qr-code-scanner.module').then(
        (m) => m.QrCodeScannerPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'vpc-haz',
    loadChildren: () => import('./pages/vpc-haz/vpc-haz.module').then((m) => m.VpcHazPageModule),
    canActivate: [AuthGuard],
    resolve: {
      appData: DataResolverService,
      currentTour: CurrentTourResolverService,
    },
  },
  {
    path: 'add-action',
    loadChildren: () =>
      import('./pages/add-action/add-action/add-action.module').then((m) => m.AddActionPageModule),
    canActivate: [AuthGuard],
    resolve: {
      appData: DataResolverService,
      currentTour: CurrentTourResolverService,
    },
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then((m) => m.LoginPageModule),
    resolve: { language: LoginResolverService },
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./pages/register/register.module').then((m) => m.RegisterPageModule),
  },
  {
    path: 'otp',
    loadChildren: () => import('./pages/otp/otp.module').then((m) => m.OtpPageModule),
  },
  {
    path: 'my-observations',
    loadChildren: () =>
      import('./pages/my-observations/my-observations.module').then(
        (m) => m.MyObservationsPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'myactivities-rating',
    loadChildren: () =>
      import('./pages/myactivities-rating/myactivities-rating.module').then(
        (m) => m.MyactivitiesRatingPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'my-actions',
    loadChildren: () =>
      import('./pages/my-actions/my-actions.module').then((m) => m.MyActionsPageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'send-email-modal',
    loadChildren: () =>
      import('./pages/send-email-modal/send-email-modal.module').then(
        (m) => m.SendEmailModalPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  // {
  //   path: 'location-selection',
  //   loadChildren: () => import('./pages/location-selection/location-selection.module').then(m => m.LocationSelectionPageModule),
  //   canActivate: [AuthGuard]
  // },
  {
    path: 'assigned-to-modal',
    loadChildren: () =>
      import('./pages/assigned-to-modal/assigned-to-modal.module').then(
        (m) => m.AssignedToModalPageModule
      ),
  },
  {
    path: 'report-dashboard',
    loadChildren: () =>
      import('./pages/report-dashboard/report-dashboard.module').then(
        (m) => m.ReportDashboardPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'language-selection',
    loadChildren: () =>
      import('./pages/language-selection/language-selection.module').then(
        (m) => m.LanguageSelectionPageModule
      ),
  },
  // {
  //   path: 'user-management-container',
  //   loadChildren: () => import('./pages/user-management-container/user-management-container.module').then(m => m.UserManagementContainerPageModule),
  //   canActivate: [AuthGuard],
  //   resolve: { appData: DataResolverService }
  // },
  // {
  //   path: 'user-management',
  //   loadChildren: () => import('./pages/user-management/user-management.module').then(m => m.UserManagementPageModule),
  //   canActivate: [AuthGuard],
  //   resolve: { appData: DataResolverService }
  // },
  {
    path: 'bog-targets',
    loadChildren: () =>
      import('./pages/bog-targets/bog-targets.module').then((m) => m.BogTargetsModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'workgroup-management',
    loadChildren: () =>
      import('./pages/workgroup-management/workgroup-management.module').then(
        (m) => m.WorkgroupManagementPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  // {
  //   path: 'more',
  //   loadChildren: () => import('./pages/more/more.module').then( m => m.MoreModule),
  //   canActivate: [AuthGuard],
  //   resolve: { appData: DataResolverService }
  // },
  {
    path: 'achievements',
    loadChildren: () =>
      import('./pages/achievements/achievements.module').then((m) => m.AchievementsModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'start-questionaire-modal',
    loadChildren: () =>
      import('./pages/start-questionaire/start-questionaire.module').then(
        (m) => m.StartQuestionairePageModule
      ),
    canActivate: [AuthGuard],
    resolve: {
      appData: DataResolverService,
      currentTour: CurrentTourResolverService,
    },
  },
  {
    path: 'my-questionnaire',
    loadChildren: () =>
      import('./pages/my-questionnaire/my-questionnaire.module').then(
        (m) => m.MyQuestionnairePageModule
      ),
  },
  {
    path: 'treasure-hunt-team-selection',
    loadChildren: () =>
      import(
        './pages/treasure_hunt/treasure-hunt-team-selection/treasure-hunt-team-selection.module'
      ).then((m) => m.TreasureHuntTeamSelectionPageModule),
    canActivate: [AuthGuard],
    resolve: { treasurehuntInfo: treasureHuntResolverService },
  },
  {
    path: 'team-registration',
    loadChildren: () =>
      import('./pages/treasure_hunt/team-registration/team-registration.module').then(
        (m) => m.TeamRegistrationPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { treasurehuntInfo: treasureHuntResolverService },
  },
  {
    path: 'treasure-hunt-dashboard',
    loadChildren: () =>
      import('./pages/treasure_hunt/treasure-hunt-dashboard/treasure-hunt-dashboard.module').then(
        (m) => m.TreasureHuntDashboardPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { treasurehuntInfo: treasureHuntResolverService },
  },
  {
    path: 'leagues',
    loadChildren: () => import('./pages/leagues/leagues.module').then((m) => m.LeaguesPageModule),
    canActivate: [AuthGuard],
    resolve: {
      appData: DataResolverService,
    },
  },
  {
    path: 'treasure-hunt-finding-discovered-list',
    loadChildren: () =>
      import(
        './pages/treasure_hunt/treasure-hunt-finding-discovered-list/treasure-hunt-finding-discovered-list.module'
      ).then((m) => m.TreasureHuntFindingDiscoveredListPageModule),
    canActivate: [AuthGuard],
    resolve: { treasurehuntInfo: treasureHuntResolverService },
  },
  {
    path: 'merge-action',
    loadChildren: () =>
      import('./pages/action_management/merge-action/merge-action.module').then(
        (m) => m.MergeActionPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'action-closure',
    loadChildren: () =>
      import('./pages/action_management/action-closure/action-closure.module').then(
        (m) => m.ActionClosurePageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'action-management',
    loadChildren: () =>
      import('./pages/action_management/action-management/action-management.module').then(
        (m) => m.ActionManagementPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'action-closure-non-hse',
    loadChildren: () =>
      import('./pages/action_management/action-closure-non-hse/action-closure-non-hse.module').then(
        (m) => m.ActionClosureNonHsePageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'action-management-non-hse',
    loadChildren: () =>
      import(
        './pages/action_management/action-management-non-hse/action-management-non-hse.module'
      ).then((m) => m.ActionManagementNonHsePageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'add-new-area',
    loadChildren: () =>
      import('./pages/area-management/add-new-area/add-new-area.module').then(
        (m) => m.AddNewAreaPageModule
      ),
    resolve: {
      appData: DataResolverService,
    },
  },
  {
    path: 'add-new-zone',
    loadChildren: () =>
      import('./pages/area-management/add-new-zone/add-new-zone.module').then(
        (m) => m.AddNewZonePageModule
      ),
    resolve: {
      appData: DataResolverService,
    },
  },
  {
    path: 'edit-zone',
    loadChildren: () =>
      import('./pages/area-management/edit-zone/edit-zone.module').then(
        (m) => m.EditZonePageModule
      ),
    resolve: {
      appData: DataResolverService,
    },
  },
  {
    path: 'edit-area-management',
    loadChildren: () =>
      import('./pages/area-management/edit-area-management/edit-area-management.module').then(
        (m) => m.EditAreaManagementPageModule
      ),
    resolve: {
      appData: DataResolverService,
    },
  },
  {
    path: 'user-rating-details',
    loadChildren: () =>
      import('./pages/area-management/user-rating-details/user-rating-details.module').then(
        (m) => m.UserRatingDetailsPageModule
      ),
    resolve: {
      appData: DataResolverService,
    },
  },
  {
    path: 'area-management-screen',
    loadChildren: () =>
      import('./pages/area-management/area-management-screen/area-management-screen.module').then(
        (m) => m.AreaManagementScreenPageModule
      ),
    canActivate: [AuthGuard],
    resolve: {
      appData: DataResolverService,
    },
  },
  {
    path: 'user-feedback',
    loadChildren: () =>
      import('./pages/user-feedback/user-feedback.module').then((m) => m.UserFeedbackPageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'qr-generated-success',
    loadChildren: () =>
      import('./pages/qr-management-update/qr-generated-success/qr-generated-success.module').then(
        (m) => m.QrGeneratedSuccessPageModule
      ),
  },
  {
    path: 'global-hse-rules',
    loadChildren: () =>
      import('./pages/global-hse-rules/global-hse-rules.module').then(
        (m) => m.GlobalHseRulesPageModule
      ),
  },
  // {
  //   path: 'key-lesson-pues-videos',
  //   loadChildren: () => import('./pages/qr-management-update/key-lesson-pues-videos/key-lesson-pues-videos.module').then(m => m.KeyLessonPuesVideosPageModule)
  // },
  {
    path: 'circuit-view',
    loadChildren: () =>
      import('./pages/circuit-view/circuit-view.module').then((m) => m.CircuitViewPageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'industrial-welfare-screen',
    loadChildren: () =>
      import(
        './pages/house-keeping/industrial-welfare-screen/industrial-welfare-screen.module'
      ).then((m) => m.IndustrialWelfareScreenPageModule),
    resolve: { appData: DataResolverService },
  },
  {
    path: 'area-overall-ratings-details',
    loadChildren: () =>
      import(
        './pages/house-keeping/area-overall-ratings-details/area-overall-ratings-details.module'
      ).then((m) => m.AreaOverallRatingsDetailsPageModule),
    resolve: { appData: DataResolverService },
  },
  {
    path: 'add-findings',
    loadChildren: () =>
      import('./pages/rapid-tour/add-findings/add-findings.module').then(
        (m) => m.AddFindingsPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'rapid-observation',
    loadChildren: () =>
      import('./pages/rapid-tour/rapid-observation/rapid-observation.module').then(
        (m) => m.RapidObservationPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'list_findings',
    loadChildren: () =>
      import('./pages/action_management/list_findings/list-findings.module').then(
        (m) => m.ListFindingsPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'admin-module',
    loadChildren: () =>
      import('./pages/admin-module/admin-module/admin-module.module').then(
        (m) => m.AdminModulePageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'housekeeping-filter',
    loadChildren: () =>
      import('./pages/house-keeping/housekeeping-filter/housekeeping-filter.module').then(
        (m) => m.HousekeepingFilterPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'update-location',
    loadChildren: () =>
      import('./pages/update-location/update-location.module').then(
        (m) => m.UpdateLocationPageModule
      ),
    resolve: { appData: DataResolverService },
  },
  {
    path: 'winners-splash-screen',
    loadChildren: () =>
      import('./pages/treasure_hunt/winners-splash-screen/winners-splash-screen.module').then(
        (m) => m.WinnersSplashScreenPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'view-team',
    loadChildren: () =>
      import('./pages/treasure_hunt/view-team/view-team.module').then((m) => m.ViewTeamPageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'finding-details',
    loadChildren: () =>
      import('./pages/treasure_hunt/finding-details/finding-details.module').then(
        (m) => m.FindingDetailsPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { treasurehuntInfo: treasureHuntResolverService },
  },
  {
    path: 'rapid-hse-program-review',
    loadChildren: () =>
      import('./pages/rapid-tour/rapid-hse-program-review/rapid-hse-program-review.module').then(
        (m) => m.RapidHSEProgramReviewPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'rapid-details-view',
    loadChildren: () =>
      import('./pages/rapid-tour/rapid-details-view/rapid-details-view.module').then(
        (m) => m.RapidDetailsViewPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'site-rapid-assessments',
    loadChildren: () =>
      import('./pages/rapid-tour/site-rapid-assessments/site-rapid-assessments.module').then(
        (m) => m.SiteRapidAssessmentsPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'maps',
    loadChildren: () => import('./pages/checkin/maps/maps.module').then((m) => m.MapsPageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'observation-feed',
    loadChildren: () =>
      import('./pages/observation-feed/observation-feed.module').then(
        (m) => m.ObservationFeedPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'treasure-hunt-station-unlock',
    loadChildren: () =>
      import(
        './pages/treasure_hunt/treasure-hunt-station-unlock/treasure-hunt-station-unlock.module'
      ).then((m) => m.TreasureHuntStationUnlockPageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'challenge-questions',
    loadChildren: () =>
      import('./pages/treasure_hunt/challenge-questions/challenge-questions.module').then(
        (m) => m.ChallengeQuestionsPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'expert-introduction',
    loadChildren: () =>
      import('./pages/treasure_hunt/TH_expert/expert-introduction/expert-introduction.module').then(
        (m) => m.ExpertIntroductionPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService, treasurehuntInfo: treasureHuntResolverService },
  },
  {
    path: 'expert-question-unlock',
    loadChildren: () =>
      import(
        './pages/treasure_hunt/TH_expert/expert-question-unlock/expert-question-unlock.module'
      ).then((m) => m.ExpertQuestionUnlockPageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'team-chat',
    loadChildren: () =>
      import('./pages/treasure_hunt/TH_chat/team-chat/team-chat.module').then(
        (m) => m.TeamChatPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'league-chat',
    loadChildren: () =>
      import('./pages/treasure_hunt/TH_chat/league-chat/league-chat.module').then(
        (m) => m.LeagueChatPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'auto-join-team',
    loadChildren: () =>
      import('./pages/treasure_hunt/auto-join-team/auto-join-team.module').then(
        (m) => m.AutoJoinTeamPageModule
      ),
  },
  {
    path: 'TH-chat',
    loadChildren: () =>
      import('./pages/treasure_hunt/TH_chat/th-chat/th-chat.module').then(
        (m) => m.THChatPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'treasure-hunt-leaderboard',
    loadChildren: () =>
      import(
        './pages/treasure_hunt/treasure-hunt-leaderboard/treasure-hunt-leaderboard.module'
      ).then((m) => m.TreasureHuntLeaderboardPageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'th-story',
    loadChildren: () =>
      import('./pages/treasure_hunt/th-story/th-story.module').then((m) => m.ThStoryPageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'team-registration-flow',
    loadChildren: () =>
      import('./pages/treasure_hunt/team-registration-flow/team-registration-flow.module').then(
        (m) => m.TeamRegistrationFlowPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'share-app',
    loadChildren: () =>
      import('./pages/share-app/share-app.module').then((m) => m.ShareAppPageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'all-shield-report',
    loadChildren: () =>
      import('./pages/All_shield_report/all-shield-report/all-shield-report.module').then(
        (m) => m.AllShieldReportPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'all-shield-verify-action',
    loadChildren: () =>
      import(
        './pages/All_shield_report/all-shield-verify-action/all-shield-verify-action.module'
      ).then((m) => m.AllShieldVerifyActionPageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'observation-add-edit',
    loadChildren: () =>
      import('./pages/observation-add-edit/observation-add-edit.module').then(
        (m) => m.ObservationAddEditPageModule
      ),
    canActivate: [AuthGuard],
    resolve: {
      appData: DataResolverService,
      currentTour: CurrentTourResolverService,
    },
  },
  {
    path: 'end-hunt-open-mystery-box',
    loadChildren: () =>
      import(
        './pages/treasure_hunt/TH-end/end-hunt-open-mystery-box/end-hunt-open-mystery-box.module'
      ).then((m) => m.EndHuntOpenMysteryBoxPageModule),
  },
  {
    path: 'end-hunt-submit',
    loadChildren: () =>
      import('./pages/treasure_hunt/TH-end/end-hunt-submit/end-hunt-submit.module').then(
        (m) => m.EndHuntSubmitPageModule
      ),
  },
  {
    path: 'end-hunt-exit',
    loadChildren: () =>
      import('./pages/treasure_hunt/TH-end/end-hunt-exit/end-hunt-exit.module').then(
        (m) => m.EndHuntExitPageModule
      ),
  },
  {
    path: 'th-end-finding-list',
    loadChildren: () =>
      import('./pages/treasure_hunt/TH-end/th-end-finding-list/th-end-finding-list.module').then(
        (m) => m.THEndFindingListPageModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'th-end-teams-story',
    loadChildren: () =>
      import('./pages/treasure_hunt/TH-end/th-end-teams-story/th-end-teams-story.module').then(
        (m) => m.THEndTeamsStoryPageModule
      ),
  },
  {
    path: 'th-end-team-picture',
    loadChildren: () =>
      import('./pages/treasure_hunt/TH-end/th-end-team-picture/th-end-team-picture.module').then(
        (m) => m.THEndTeamPicturePageModule
      ),
  },
  {
    path: 'bonus-introduction',
    loadChildren: () =>
      import('./pages/treasure_hunt/th_bonus/bonus-introduction/bonus-introduction.module').then(
        (m) => m.BonusIntroductionPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService, treasurehuntInfo: treasureHuntResolverService },
  },
  {
    path: 'bonus-question-unlock',
    loadChildren: () =>
      import(
        './pages/treasure_hunt/th_bonus/bonus-question-unlock/bonus-question-unlock.module'
      ).then((m) => m.BonusQuestionUnlockPageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService, treasurehuntInfo: treasureHuntResolverService },
  },
  {
    path: 'fire-flame',
    loadChildren: () =>
      import('./pages/fire-flame/fire-flame.module').then((m) => m.FireFlamePageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'fire-streak',
    loadChildren: () =>
      import('./pages/fire-streak/fire-streak.module').then((m) => m.FireStreakPageModule),
  },
  {
    path: 'performance',
    loadChildren: () => import('./pages/performance-v2/performance-v2.module').then( m => m.PerformanceV2PageModule),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  //{
  //   path: 'performance',
  //   loadChildren: () => import('./pages/performance/performance.module').then( m => m.PerformancePageModule),
  //   canActivate: [AuthGuard],
  //   resolve: { appData: DataResolverService } 
  // },
  {
    path: 'rapid-draft',
    loadChildren: () =>
      import('./pages/rapid-tour/rapid-draft/rapid-draft.module').then(
        (m) => m.RapidDraftPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'finding-action-list',
    loadChildren: () =>
      import('./pages/All_shield_report/finding-action-list/finding-action-list.module').then(
        (m) => m.FindingActionListPageModule
      ),
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
  },
  {
    path: 'add-edit-beacon',
    loadChildren: () => import('./pages/area-management/add-edit-beacon/add-edit-beacon.module').then( m => m.AddEditBeaconPageModule)
  },
  {
    path: 'shield',
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
    loadChildren: () => import('./pages/shield/shield.module').then( m => m.ShieldPageModule)
  },
  {
    path: 'structural-assessment/:id',
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
    loadChildren: () => import('./pages/assessment/structural-assessment/structural-assessment.module').then( m => m.StructuralAssessmentPageModule)
  },
  {
    path: 'structure-finding-details/:id',
    canActivate: [AuthGuard],
    resolve: { appData: DataResolverService },
    loadChildren: () => import('./pages/assessment/structure-finding-details/structure-finding-details.module').then( m => m.StructureFindingDetailsPageModule)
  
  },{
    path: 'th-request-sponsorship',
    loadChildren: () => import('./pages/treasure_hunt/th-request-sponsorship/th-request-sponsorship.module').then( m => m.ThRequestSponsorshipPageModule)
  },
  {
    path: 'i-hunt',
    loadChildren: () => import('./pages/treasure_hunt/i-hunt/i-hunt.module').then( m => m.IHuntPageModule)
  },
  {
    path: 'th-findings-listing',
    loadChildren: () => import('./pages/treasure_hunt/th-findings-listing/th-findings-listing.module').then( m => m.ThFindingsListingPageModule)
  },
  {
    path: 'th-finding-details',
    loadChildren: () => import('./pages/treasure_hunt/th-findings-detail/th-findings-detail.module').then(m => m.ThFindingsDetailPageModule)
  },
  {
    path: 'th-mystery-box',
    loadChildren: () => import('./pages/treasure_hunt/th-mystery-box/th-mystery-box.module').then(m => m.ThMysteryBoxPageModule)
  },
   {
    path: 'zone-management-screen',
    loadChildren: () =>
      import('./pages/area-management/zone-management-screen/zone-management-screen.module').then(
        (m) => m.ZoneManagementScreenPageModule
      ),
    canActivate: [AuthGuard],
    resolve: {
      appData: DataResolverService,
    },
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(ROUTES, {
      useHash: true,
    }),
  ],
  exports: [RouterModule],
  providers: [DataResolverService],
})
export class AppRoutingModule {}
